var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('header-nav'),_vm._v(" "),_c('div',{staticClass:"content"},_vm._l((_vm.agreementTxt),function(i,index){return _c('div',{key:index,staticClass:"content__item"},[(i === ' ')?_c('div',[_vm._v("111")]):(i)?_c('div',[_vm._v(_vm._s(_vm.formatTxt(i)))]):_c('div',[_c('br')])])}),0),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-353045ad","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/agreement.vue
// module id = null
// module chunks = 